'use client'
import Footer from '@/components/Footer/FooterHome'
import { useState, useEffect } from 'react'

import {
  HeroHome,
  Testimonials,
  Influencers,
  TypesTrainings,
  NutritionistTime,
  Lapa,
  PlansCompare,
  Partners,
  Faq
} from '@/sections'

import Cases from '@/sections/Cases'
import TypesTrainingNew from '@/sections/TypesTrainingNew'
import InfluencersNew from '@/sections/InfluencersNew'

import { Header, Modal, ButtonFixed, FormSoftlead, If } from '@/components'

import styles from './styles.module.scss'

import { useExperiment } from 'rvbr-www/red-testing'
import clarity from '@/utils/clarity'

export default function Home() {
  const [openModal, setOpenModal] = useState(false)
  const [productId, setProductId] = useState('play')
  const [hasMounted, setHasMounted] = useState(false)
  const { variant } = useExperiment('influencers-typeTraining')

  useEffect(() => {
    clarity.setTags([
      { name: 'redtestingType', value: 'active' },
      { name: 'redtestingExperiment', value: variant?.experimentId },
      { name: 'redtestingVariant', value: variant?.id }
    ])

    setHasMounted(true)
  }, [])

  if (!hasMounted) return <></>

  return (
    <>
      <Header hasLogin />
      <main className={styles.home}>
        <HeroHome />
        <Cases />
        <Testimonials />
        <If
          condition={variant.id === 'b' || variant.id === 'd'}
          renderIf={<InfluencersNew />}
          renderElse={<Influencers />}
        />
        <If
          condition={variant.id === 'c' || variant.id === 'd'}
          renderIf={<TypesTrainingNew />}
          renderElse={
            <TypesTrainings
              smallDisclaimer="*Fonte: Valor Investe, Superprof, FNN, SDPESP, Neon"
              description="Somando o valor de todos os treinos disponíveis eles valeriam mais de R$1.265,27, mas na Academia Foguete você pode aproveitar todo esse conteúdo por a partir de R$29,90 por mês.*"
            />
          }
        />
        <NutritionistTime />
        <Lapa />
        <PlansCompare
          onPlanSelected={setProductId}
          setOpenModal={setOpenModal}
        />
        <Partners />
        <Faq />
        <ButtonFixed
          buttonId={'lp-button-fixed'}
          label={'QUERO EXPERIMENTAR'}
          elementIdStart={'cases'}
          elementIdToGo={'comparePlans'}
          elementIdEnd={'comparePlans'}
        />
        {openModal && (
          <div className={styles.modal}>
            <Modal
              isOpened={openModal}
              onCloseClick={() => setOpenModal(false)}
              variant={'center'}
              hasFooterButton={false}
            >
              <FormSoftlead className={styles.form} productId={productId} />
            </Modal>
          </div>
        )}
      </main>
      <Footer />
    </>
  )
}
